import { render, staticRenderFns } from "./mktIcon.vue?vue&type=template&id=b824e4bc&"
import script from "./mktIcon.vue?vue&type=script&lang=js&"
export * from "./mktIcon.vue?vue&type=script&lang=js&"
import style0 from "./mktIcon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports